// changelog.js — TDA Events Platform
// Neueste Version zuerst. Typen: feature | major | improvement | bugfix | security

export const CHANGELOG = [
  {
    version: '2.7.11',
    date: '2026-10-25',
    type: 'improvement',
    title: 'Vereinsanmeldung Schritt für Schritt: einfache Klassenwahl, Hilfen, Karten am Handy',
    highlights: [
      'Geführte Anmeldung in vier Schritten mit Fortschrittsanzeige: Sportler, Klassen, Prüfen und Startgeld, Fertig. Vorher eine Checkliste, was man braucht',
      'Klassenwahl in einfachen Worten: erst die Disziplin, dann nur die passenden Klassen mit deutschem Namen. Alle Klassen bleiben auf Wunsch sichtbar',
      'Kleine ?-Hilfen an den wichtigen Stellen und ein Hilfe-Knopf mit dem Kontakt des Veranstalters',
      'Partner für Duo und Team aus den eigenen Sportlern wählen',
      'Im Vereinsbereich Karten statt Tabellen am Handy',
      'Fehlt dem Turnier die Bankverbindung, bekommt der Verein einen klaren Hinweis und der Veranstalter eine Meldung in der Turnierverwaltung',
      'Die Turnierverwaltung zeigt, wie viele Vereine die Anmeldung begonnen und abgeschlossen haben und wo sie hängen bleiben',
    ],
  },
  {
    version: '2.7.10',
    date: '2026-10-25',
    type: 'bugfix',
    title: 'Vereinsanmeldung einfacher: Registrierung repariert, Fehler direkt am Feld, Bestätigungsseite',
    highlights: [
      'Registrierung funktioniert wieder ohne Hausnummer, Postleitzahlen mit 4 oder 5 Ziffern',
      'Registrierungsseite neu gestaltet, mit sichtbaren Schritten und großen Knöpfen',
      'Eine Passwortregel für alle Konten, als Liste zum Abhaken, die beim Tippen grün wird',
      'Fehler stehen direkt am Feld mit genauem Grund statt „Registrierung fehlgeschlagen“',
      'Wer aus einer Ausschreibung kommt, landet nach Registrierung oder Login direkt bei der Anmeldung zu diesem Turnier',
      'Sportler anlegen: Geschlecht nicht mehr vorbelegt, „Erfahrung“ statt „Skill Level“, Foto-Einwilligung beim Sportler',
      'Nach dem Absenden eine Bestätigungsseite mit Startgeld und nächsten Schritten',
      'Tabellen im Vereinsbereich werden am Handy nicht mehr abgeschnitten',
    ],
  },
  {
    version: '2.7.9',
    date: '2026-10-25',
    type: 'improvement',
    title: 'Turnier-Einstellungen neu, Kampfuhr aus den Einstellungen, Verlängerung und Goldener Punkt',
    highlights: [
      'Neue Seite Turnier-Einstellungen: Gruppen mit Status, Bearbeiten in der Mitte, Seitenleiste mit Zusammenfassung. Warnung vor ungespeicherten Änderungen',
      'Die Kampfuhr im Schreiber-Panel und in der Kampfrichter-App übernimmt Rundenzeit und Pause aus den Einstellungen. Der Schreiber kann abweichen',
      'Bei Gleichstand eine Verlängerung oder Goldener Punkt nach Einstellung, danach Kampfrichterentscheid. Die Punktetafel zeigt den Stand an',
      'Zeiten lassen sich mit Sekunden eingeben, zum Beispiel 1:30',
      'Der Zeitplan rechnet je Disziplin richtig, mit Kampfdauer, Rumble, Finale, Kids, Erholungszeit, Kampf um Platz 3 und einer Reserve für Verlängerungen',
      'Neue Formen-Kategorien übernehmen Notenbereich und Kampfrichterzahl aus den Wertungs-Einstellungen',
      'Kürzel GP für Goldenen Punkt und KE für Kampfrichterentscheid in Kampfliste und Zuschaueransicht',
      'Behoben: Standard-Zeitplan speichern, die Kampfuhr startete mit Testzeiten',
    ],
  },
  {
    version: '2.7.8',
    date: '2026-10-23',
    type: 'improvement',
    title: 'Formenkatalog neu: gruppiert, Seitenleiste, Bearbeiten und alle 24 Hyongs',
    highlights: [
      'Neuer Formenkatalog: gruppiert nach Disziplin und Stil, alles einklappbar, auf Wunsch als Liste',
      'Seitenleiste mit Schreibweisen, Quellen und wo die Form am Turniertag gewählt wurde',
      'Formen lassen sich anlegen, bearbeiten und zusammenlegen. Löschen ist gesperrt, solange eine Form gewählt wurde',
      'Taekwondo ITF und Chang-Hon zusammengeführt: alle 24 Formen, auch unter „Hyong“ und „Tul“ auffindbar',
      'Quellen für alle Formen hinterlegt, Umlaute in den Hinweisen korrigiert',
    ],
  },
  {
    version: '2.7.7',
    date: '2026-10-23',
    type: 'improvement',
    title: 'Punktetafel übernimmt Farben und Beschriftungen aus der Modus-Übersicht',
    highlights: [
      'Die AO- und AKA-Farben aus der Modus-Übersicht färben auf der neuen Punktetafel die Seitenschilder und Markierungen. Ohne eigene Einstellung bleibt alles wie bisher',
      'Eigene Beschriftungen ersetzen ROT und BLAU auf der Tafel, höchstens acht Zeichen',
      'Die Schrift auf den Schildern wird bei hellen Farben automatisch dunkel',
      'Die Vorschau in der Modus-Übersicht zeigt Farben und Beschriftungen sofort',
    ],
  },
  {
    version: '2.7.6',
    date: '2026-10-23',
    type: 'improvement',
    title: 'Divisionen: Hauptkategorien einklappbar, Zusammenlegen mit Rückgängig und Mitteilung an Vereine',
    highlights: [
      'In der gruppierten Ansicht lassen sich die Hauptkategorien wie Formen, Kickboxen oder Grappling ein- und ausklappen, dazu „Alle zuklappen“ und „Alle aufklappen“. Der Zustand bleibt gemerkt',
      'Zusammenlegen wird protokolliert und lässt sich zurücknehmen, solange keine der beiden Klassen gestartet ist',
      'Betroffene Vereine sehen in ihrem Bereich eine Mitteilung, wenn ein Starter in eine andere Klasse umgesetzt wurde',
      'Einheitliche Schreibweise beim Geschlecht der Divisionen, der Server prüft sie beim Speichern',
      'Für den Plattformbetrieb heißt die Turnierauswahl jetzt „Alle Turniere“',
    ],
  },
  {
    version: '2.7.5',
    date: '2026-10-23',
    type: 'improvement',
    title: 'Divisionen neu: gruppiert nach Disziplin, Seitenleiste mit Startern, Sicherheit je Verband',
    highlights: [
      'Neue Divisionen-Seite: gruppiert nach Disziplin und Klassenart, auf Wunsch als flache Liste. Die gewählte Ansicht bleibt gemerkt',
      'Kennzahlen je gewähltem Turnier: Divisionen mit Meldungen, Einzelstarter ohne Gegner und Klassen mit uneinheitlicher Schreibweise',
      'Seitenleiste mit Einteilung, gemeldeten Startern (wer nicht passt, ist markiert) und den Gewichtsklassen daneben zum Zusammenlegen',
      'Bearbeiten prüft Alter und Gewicht direkt am Feld. „Alter von 0“ wird nicht mehr zu leer',
      'Eine Division, die ein Turnier verwendet, lässt sich nicht löschen. Sonst nur nach Eingabe des Codes',
      'Divisionen und Meldezahlen sind strikt je Verband getrennt, Vereine sehen nur Turniere, für die sie sich anmelden können',
    ],
  },
  {
    version: '2.7.4',
    date: '2026-10-22',
    type: 'improvement',
    title: 'Vereinsverwaltung neu: Liste mit Seitenleiste, Sperren, Archiv ohne Datenverlust',
    highlights: [
      'Neue Vereinsverwaltung: Liste mit Kennzahlen und Seitenleiste mit Kontakt und Aktionen, am Handy Liste und Vereinsseite nacheinander',
      'Vereinsseite mit Zahlen und Reitern für Wettkämpfer, Anmeldungen, Helfer und Vereinsdaten. Beim Bearbeiten stehen Fehler direkt am Feld',
      'Vereine lassen sich sperren und wieder freigeben, mit Grund. Ein gesperrtes Konto kann sich nicht mehr anmelden',
      'Archivieren blendet Verein und Wettkämpfer nur noch aus: Meldungen, Ergebnisse und Ranglistenpunkte bleiben erhalten. Zurückholen stellt alles wieder her',
      'Endgültiges Löschen nur nach Eintippen des Vereinsnamens, der Dialog nennt, was wegfällt',
      'Verwaltungskonten stehen getrennt und zählen nicht als Verein',
      'Helfer und Kampfrichter lassen sich einem Verein zuordnen',
    ],
  },
  {
    version: '2.7.3',
    date: '2026-10-22',
    type: 'security',
    title: 'Vereinsdaten nur im eigenen Verband',
    highlights: [
      'Verwaltung von Vereinen, Archiv und Wettkämpferzahlen strikt je Verband. Ein Verbandsadmin sieht und ändert nur Vereine seines Verbands',
      'Archivierte Vereine sehen nur Admins. Beim Zurückholen bleibt der Verein in seinem Verband',
      'In der Vereinsliste sehen Vereine von anderen Vereinen nur Name und Ort, Kontaktdaten nur Admins',
    ],
  },
  {
    version: '2.7.2',
    date: '2026-10-22',
    type: 'improvement',
    title: 'Ausschreibungs-PDF deutlich kleiner',
    highlights: [
      'Plakat und Logos werden vor dem Einbetten auf Druckqualität verkleinert. Eine Ausschreibung mit großem Plakat hat statt 4,5 MB nur noch rund 0,6 MB und lädt am Handy schneller',
    ],
  },
  {
    version: '2.7.1',
    date: '2026-10-22',
    type: 'improvement',
    title: 'Nachmeldung am Turniertag, Ausschreibungs-PDF im japanischen Stil, neue Bildschirme in der Modus-Übersicht',
    highlights: [
      'Anmeldung auch während des Turniers, solange die Kategorie noch nicht gestartet ist. Gestartete Kategorien sind in allen Anmeldemasken und in der Ausschreibung ausgegraut, der Server lehnt sie ab',
      'Das Feld „Nachmeldung bis“ in der Turniermaske wirkt jetzt: danach ist die Anmeldung geschlossen. Ausschreibung und PDF nennen die Frist',
      'Ausschreibung als PDF neu gestaltet: Titelseite mit Plakat, Eckdaten und QR-Code, danach Programm, Kategorien, Startgeld, Regeln, Hotels und Hinweise auf mehreren Seiten',
      'Modus-Übersicht, Reiter Anzeige: die Vorschau zeigt die neuen Turniertag-Bildschirme. Für Punktetafel, Kata-Tafel und Turnierbaum lässt sich zwischen neuer und bisheriger Optik wählen',
      'Detailansicht der Modus-Übersicht über die ganze Seite, nichts läuft mehr rechts hinaus',
      'Eigene Kontaktseite, der Menüpunkt „Kontakt“ führte bisher ins Leere',
      'Menüleiste in Weiß statt Rot, größeres Logo. Plakat der Ausschreibung größer und per Klick groß ansehen',
      'Zweifaktor einrichten: größerer QR-Code, Knopf „In App öffnen“, Anleitung für Apple Passwörter, Schlüssel zum Kopieren. Die Seite ist jetzt auch im hellen Modus lesbar',
    ],
  },
  {
    version: '2.7.0',
    date: '2026-10-22',
    type: 'major',
    title: 'Neue Veranstaltungsübersicht, Ausschreibung je Turnier und Abrechnung für Veranstalter',
    highlights: [
      'Neue Übersicht aller Veranstaltungen: als Liste nach Monaten, als Karten oder als Kalender, mit Logo, Suche und Filtern nach Monat, Disziplin, Region und Art. Vergangene Veranstaltungen lassen sich zuschalten',
      'Neue Ausschreibung je Turnier mit allen Angaben auf einer Seite: Zeitplan, Kampfzeiten, Schutzausrüstung, Startgeld, Anmeldung, Hotels, Anfahrt und Dokumente zum Herunterladen. Am Handy bleibt der Anmeldeknopf unten stehen',
      'Neuer Schritt „Ausschreibung“ im Turnier-Assistenten und eigener Reiter in der Turniermaske. PDF-Anhänge lassen sich hochladen und einzeln freigeben',
      'Verbandsvorlagen für Haftung, Datenschutz und Versicherung: einmal je Verband hinterlegt, je Turnier übernommen und dort änderbar',
      'Neues Feld „Art des Turniers“: Turnier, Meisterschaft, Ranglistenturnier, Lehrgang oder Sonstiges. Steht als Abzeichen in Übersicht und Ausschreibung und lässt sich filtern',
      'Veranstalter-Abrechnung für den Plattformbetrieb: Übersicht je Turnier, Rechnung als PDF, Storno und Gutschrift. Berechnet werden nur bezahlte Starts, die Umsatzsteuer richtet sich nach dem Land des Veranstalters',
      'In der Mitgliederverwaltung angeschlossener Schulen führt der Link zum Turnier jetzt direkt auf die Ausschreibung, das Turnierlogo wird mitgeschickt',
      'Die Chat-Blase verdeckt am Handy den Anmeldeknopf der Ausschreibung nicht mehr',
    ],
  },
  {
    version: '2.6.3',
    date: '2026-10-22',
    type: 'improvement',
    title: 'Turnierverwaltung nach Termin sortiert',
    highlights: [
      'Kommende Turniere stehen oben, das nächste zuerst. Darunter die vergangenen, das jüngste zuerst. Turniere ohne Datum ganz unten',
      '„Für Veranstalter“ in der Menüleiste nicht mehr rot hervorgehoben',
    ],
  },
  {
    version: '2.6.2',
    date: '2026-10-22',
    type: 'improvement',
    title: 'Matte läuft durch: nächste Kategorie jeder Art, Siegerehrung auf der Kata-Tafel',
    highlights: [
      'Die nächste Kategorie einer Matte wird immer aufgerufen, ob Formen, Selbstverteidigung, Kampf oder Bruchtest. Auch nach dem letzten Kampf einer Kampf-Kategorie geht es von selbst weiter',
      'Nach dem Abschließen zeigt die Kata-Tafel zuerst die Siegerehrung mit Podest, danach die Ankündigung der nächsten Kategorie',
      'Formen- und Selbstverteidigungs-Panel wechseln von selbst zur aufgerufenen Kategorie. Wird gerade gewertet, fragen sie vorher. Von Hand wechseln geht jederzeit',
      'Neuer Knopf „Wieder öffnen“ für fertige Kategorien, die Wertungen bleiben erhalten',
    ],
  },
  {
    version: '2.6.1',
    date: '2026-10-21',
    type: 'improvement',
    title: 'Formen: Kategorie abschließen und nächste Kategorie aufrufen',
    highlights: [
      'Neuer Knopf „Kategorie abschließen“ im Formen- und Selbstverteidigungs-Panel. Die Kategorie wandert von „Offen“ nach „Fertig“ und lässt sich dort noch ansehen',
      'Danach wird die nächste Kategorie der Matte aufgerufen, mit Aufruf-Schirm und Sprachansage. Die Kata-Tafel kündigt sie groß mit Starterliste an',
      'Wird eine Kategorie früher oder später fertig, rücken die Startzeiten der folgenden Kategorien auf der Matte nach. Die gedruckte Planzeit für Vereine bleibt',
      'Siegerehrung: gerade abgeschlossene Kategorien erscheinen ohne Neuladen, Sieger stimmen mit Urkunde überein, Blättern springt nicht mehr',
      'Abgeschlossene Kategorien nehmen keine Wertungen mehr an, auch nicht aus der Kampfrichter-App',
    ],
  },
  {
    version: '2.6.0',
    date: '2026-10-21',
    type: 'major',
    title: 'Turniertag in neuer Optik: Punktetafel, Turnierbaum, Kata und Siegerehrung',
    highlights: [
      'Neue Punktetafel auf dem Mattenbildschirm für jeden Kampf: Runde, Kategorie, Bild der Kämpfer, Verwarnungen, Minuspunkte, letzte Wertung mit Technik und der nächste Kampf auf der Matte. Wer führt, steht groß oben',
      'Verwarnungen in allen Kampfsportarten einheitlich: die ersten zwei sind Verwarnungen, ab der dritten gibt jede einen Minuspunkt. Eine automatische Disqualifikation lässt sich je Disziplin und Turnier einstellen',
      'Gleichstand bei Zeitende: in der Kampfrichter-App gibt es eine Verlängerung, die Tafel zeigt „1. Verlängerung“, im Ergebnis steht „n. V.“',
      'Pointfighting in der Kampfrichter-App mit Fauststoß +1, Fußtritt zum Körper +2 und Fußtritt zum Kopf +3',
      'Der Turnierbaum zeigt jeden Sieg mit Animation: der Sieger rückt mit großer Bildkarte eine Runde weiter, der Verlierer wandert in die Trostrunde. Nur die laufende Runde ist hervorgehoben. Abschaltbar',
      'K.-o. mit Trostrunde: jeder Verlierer kämpft weiter um Platz 3, ein Dritter wird ausgekämpft. Plätze ab 5 ohne Lücken',
      'Neue Kata-Tafel mit Noten der Kampfrichter, Streichwertung, Rangliste in Gold, Silber und Bronze, nächstem Starter und Starterliste',
      'Formen werden beim Starter aus einer Liste gewählt: über 400 Formen aus Karate und Taekwondo, dazu freie und Musikformen',
      'Neue Siegerehrung auf dem Hallenbildschirm mit Podest, Ergebnisliste und allen weiteren Plätzen',
      'Fotos der Sportler erscheinen auf Hallenbildschirmen nur mit Einwilligung, die beim Hochladen abgefragt wird, und nur über den Hallenschlüssel der Turnierleitung. Ein Schlüssel gilt für alle Hallenbildschirme',
      'Hochgeladene Sportlerfotos sind nicht mehr frei über ihre Adresse abrufbar',
    ],
  },
  {
    version: '2.5.0',
    date: '2026-10-21',
    type: 'major',
    title: 'Vom Anlegen bis zum Abschluss: Turniere in klaren Schritten',
    highlights: [
      'Jedes Turnier durchläuft einen festen Ablauf: Entwurf, Anmeldung offen, Anmeldung geschlossen, läuft, abgeschlossen. Der nächste Schritt steht immer als Knopf bereit',
      'Neue Turniere entstehen mit einem Assistenten in vier Schritten. „Aus Vorjahr übernehmen“ kopiert ein Turnier mit allen Einstellungen als Entwurf',
      'Vereine melden im Vereinsbereich mehrere Sportler auf einmal an, auch „wie beim letzten Turnier“ oder per CSV-Datei',
      'Eine Anmeldeseite für alle Konten. Helfer am Turniertag bekommen ein Personalkonto mit Einladung per Link, das für Check-in, Waage und Kampfrichter-App gilt',
      'Die Leitstelle zeigt am Turniertag alle Matten, Verzug, Tablets und Meldungen auf einen Blick. Vor dem Start prüft eine Liste, ob alles bereit ist',
      'Ein Übungsturnier zum Ausprobieren: es läuft wie ein echtes Turnier, erscheint aber nirgends öffentlich und verschickt keine Mails an Vereine',
      'Pools mit drei Startern laufen als „Jeder gegen jeden“ mit Rangtabelle. Bei Gleichstand setzt die Leitstelle einen Stichkampf an',
      'Plätze werden vollständig vergeben: im K.-o.-System ab Platz 4, ohne Kampf um Bronze mit zwei geteilten Dritten',
      'Der Abschluss-Assistent führt in sieben Schritten durch die Nachbereitung: Urkunden als PDF, Abrechnung je Verein mit Zahlungserinnerung, Ergebnis-Mail mit Testmail vorab, Pressetext und Bild für soziale Netzwerke',
      'Fotogalerie zum Turnier: öffentlich erscheint ein Foto nur, wenn alle markierten Personen bei der Anmeldung eingewilligt haben. Bei Minderjährigen bestätigt der Verein die Einwilligung der Eltern',
      'Kurze Umfrage nach dem Turnier, anonym, mit Link und QR-Code zum Aushängen und einer Auswertung im Dashboard',
      'Saison-Rangliste je Verband mit Punkten, Gruppen und Mindestbesetzung, erst nach Veröffentlichung sichtbar',
      'Ergebnisse, Ranglisten und Hallenschirme wechseln sanft, wenn sich etwas ändert, statt zu springen',
      'Am Handy ohne waagrechtes Scrollen, im hellen und dunklen Modus gut lesbar. Rückmeldungen erscheinen als kurze Hinweise statt als Fenster',
    ],
  },
  {
    version: '2.4.0',
    date: '2026-09-27',
    type: 'feature',
    title: 'Einzelstarter, Turnierinfo und Mails an Vereine',
    highlights: [
      'Neue Ansicht „Einzelstarter": wer allein in seiner Kategorie steht, mit passenden Vorschlägen, Umlegen und Nachricht an den Verein',
      'Neue Ansicht „Mails an Vereine": Anmeldebestätigung und Turnierinfo mit Matte und Uhrzeit je Start, mit Vorschau',
      'Vereine sehen im Vereinsbereich Matte und geplante Uhrzeit ihrer Starts',
      'Alle Mails an Vereine werden archiviert und kommen zuverlässiger an',
    ],
  },
  {
    version: '2.3.2',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Anmeldung am Handy bedienbar, mit Tipps',
    highlights: [
      'Am Handy nutzt das Anmeldefenster den ganzen Bildschirm; Wettkämpfer und Kategorien sind erreichbar',
      'Kurze Tipps in jedem Schritt, wegklickbar',
      'Fehlendes Gewicht steht schon bei der Auswahl der Wettkämpfer, nicht erst bei den Kategorien',
      'Weniger Knöpfe: Unterfilter erscheinen erst nach Wahl einer Disziplin, Vereine sehen nur ihre zwei Schritte',
    ],
  },
  {
    version: '2.3.1',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Teamgebühr je Team, strenge Kategorieprüfung, Lehrgänge mit Zahlung',
    highlights: [
      'Die Teamgebühr gilt je Team: aufgeteilt auf die Mitglieder oder als eine Position für den Verein, wählbar je Turnier',
      'Alter, Geschlecht, Gewicht und Stufe werden beim Anmelden verbindlich geprüft, das Alter zum Stichtag des Turniers',
      'Lehrgänge zeigen nach der Anmeldung Betrag, Bankverbindung und Verwendungszweck',
      'Die Warteliste rückt automatisch nach, wenn jemand absagt oder mehr Plätze frei werden',
    ],
  },
  {
    version: '2.3.0',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Jede Veranstaltung bekommt das passende Formular',
    highlights: [
      'Passdaten fragt nur noch das Camp ab; Lehrgänge und Seminare brauchen Name und E-Mail',
      'Veranstaltungen mit persönlicher Einladung zeigen Beschreibung und Uhrzeit statt eines Formulars',
      'Zustimmung zur Datenverarbeitung, Schutz gegen doppelte Anmeldungen und Formular-Bots',
      'Am Handy einspaltig, mit Kopfzeile und Weg zurück zur Übersicht',
    ],
  },
  {
    version: '2.2.9',
    date: '2026-09-27',
    type: 'improvement',
    title: 'Anmeldung für Vereine in einem Schritt',
    highlights: [
      '„Anmelden" führt direkt zu Sportlern und Kategorien, ohne Umweg über eine zweite Seite',
      'Teamname und Teammitglieder bei Duo- und Team-Kategorien bleiben gespeichert',
      'Schnellanmeldung und Athletenkonto fragen das Gewicht ab, das für die Gewichtsklasse nötig ist',
      'Angeboten werden nur noch die Kategorien, die der Veranstalter für das Turnier ausgeschrieben hat',
      'QR-Schnellanmeldungen lassen sich freigeben und bekommen ihre Startgebühr',
      'Nach einem Storno ist eine erneute Anmeldung in derselben Kategorie möglich',
    ],
  },
  {
    version: '2.2.8',
    date: '2026-08-07',
    type: 'security',
    title: 'Schnittstellen geben weniger preis',
    highlights: [
      'Status- und Fehlerauskünfte nennen keine internen Kennzahlen und keine Endpunktlisten mehr',
      'Der Divisionen-Katalog ist an eine Anmeldung gebunden; die Anmeldelinks nutzen ihren eigenen Zugang',
      'Anlegen, Ändern und Löschen von Kategorien meldet sich wieder korrekt an',
    ],
  },
  {
    version: '2.2.7',
    date: '2026-07-08',
    type: 'feature',
    title: 'Teilnehmer laden Brief selbst herunter',
    highlights: [
      'Nach der Selbst-Anmeldung: Download-Button für den eigenen Visa-Einladungsbrief',
      'Token-geschützt (kein Zugriff auf fremde Briefe/Passdaten)',
    ],
  },
  {
    version: '2.2.6',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Events im Header-Dropdown + Modal-Fix',
    highlights: [
      'Header-Dropdown listet jetzt auch „Events & Camps" (neben Turnieren)',
      'Dialoge opak & höhenbegrenzt (scrollen im Rahmen) – nicht mehr durchsichtig',
    ],
  },
  {
    version: '2.2.5',
    date: '2026-07-08',
    type: 'feature',
    title: 'Camp-Selbstanmeldung per Link',
    highlights: [
      'Öffentlicher Anmelde-Link je Camp – Teilnehmer tragen ihre Passdaten selbst ein (/camp/:id)',
      'Zweisprachiges Formular (EN/DE), kein Login nötig',
      'Link im Camp-Panel kopierbar; Admin-Fallback „Teilnehmer hinzufügen"',
    ],
  },
  {
    version: '2.2.4',
    date: '2026-07-08',
    type: 'bugfix',
    title: 'Menüpunkt „Lehrgänge & Camps"',
    highlights: [
      'Events-/Camp-Bereich war nicht im Menü verlinkt – jetzt Kachel in der Organisation-Übersicht',
      'Trainingscamps inkl. Visa-Briefe-Assistent darüber erreichbar',
    ],
  },
  {
    version: '2.2.3',
    date: '2026-07-08',
    type: 'feature',
    title: 'Briefe-Assistent: drucken, per E-Mail senden, Kopien',
    highlights: [
      'Assistent: Sammelbrief / Einzelbrief / Einzelbriefe an alle Teilnehmer',
      'Ausgabe wählbar: PDF herunterladen (Ausdruck) oder per E-Mail',
      'E-Mail-Empfänger: Botschaft, Teilnehmer oder eigene Adresse',
      'Anzahl Ausfertigungen (Kopien) je Brief einstellbar; Botschafts-E-Mail speicherbar',
    ],
  },
  {
    version: '2.2.2',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Visa-Brief mit Verbands-Briefkopf & gebrandete E-Mail',
    highlights: [
      'Offizieller Briefkopf mit TDA-Verbandslogo (Tiger & Dragon Association Int\'l) im PDF',
      'Begleit-E-Mail im TDA-Markenlayout (Banner) statt Klartext',
    ],
  },
  {
    version: '2.2.1',
    date: '2026-07-08',
    type: 'improvement',
    title: 'Visa-Brief: fester Absender pro Camp',
    highlights: [
      'Absender (Organisation, Ansprechpartner, Anschrift, E-Mail, Telefon) pro Camp hinterlegbar',
      'Erscheint fest im Briefkopf & in der Unterschrift – unabhängig vom Login-Konto',
    ],
  },
  {
    version: '2.2.0',
    date: '2026-07-07',
    type: 'feature',
    title: 'Trainingscamp & Visa-Einladungsbriefe',
    highlights: [
      'Event-Typ "Camp" mit Botschafts-/Visa-Daten (Zielland, Botschaftsanschrift)',
      'Passdaten je Teilnehmer erfassen (Reisepass, Nationalität, Geburtsort, Anschrift)',
      'Einzel-Einladungsbrief pro Teilnehmer als PDF – zweisprachig Deutsch/Englisch',
      'Sammel-Nominierungsschreiben mit Teilnehmer-Tabelle als PDF (DE/EN)',
    ],
  },
  {
    version: '2.1.0',
    date: '2026-03-23',
    type: 'feature',
    title: 'Staff-Management & Einsatzplan',
    highlights: [
      'Neue Rollen: Turnierleitung, Anmeldung, Ombudsmann',
      'Mehrere Rollen pro Person möglich',
      'Vollständiger Einsatzplan mit Matten-Raster',
      'Rollenbasierte Filterung in Zuweisung-Dropdowns',
    ],
  },
  {
    version: '2.0.0',
    date: '2026-03-20',
    type: 'major',
    title: 'Formen-Übersicht & Mattenfläche',
    highlights: [
      'Formen-Dashboard: Kategorie-Übersicht mit Matte-Zuweisung',
      'Neuer Mattenfläche-Bereich mit Schreiber-Links',
      'Turnier-Auswahl jetzt im globalen Header sichtbar',
      'Hilfe-Modal mit Modulbeschreibungen und Versionierung',
    ],
  },
  {
    version: '1.9.0',
    date: '2026-03-10',
    type: 'feature',
    title: 'Saison-Rangliste',
    highlights: [
      'Saison-Rangliste für TDA-weit verwaltbar',
      'Öffentliches Widget für tda-intl.com und tda-vib.de',
      'Veröffentlichen / Zurückziehen per Schalter',
    ],
  },
  {
    version: '1.8.0',
    date: '2026-02-15',
    type: 'feature',
    title: 'Kampfflächen-Manager',
    highlights: [
      'Matten und Bereiche anlegen und benennen',
      'Matten Formen-Kategorien zuordnen',
      'Nummernvergabe für Mattenübersicht',
    ],
  },
  {
    version: '1.7.0',
    date: '2026-01-20',
    type: 'improvement',
    title: 'Wettkämpfer-Dashboard Überarbeitung',
    highlights: [
      'Kompakte Filter-Leiste (Gewicht, Alter, Level in einer Zeile)',
      'Statistik-Chips statt großer Stat-Karten',
      'Schnellsuche nach Name',
    ],
  },
];
